export default __webpack_public_path__ + "static/media/questionsets.a26b78a9.svg";